export class SampleModel {
  SampleId: number;
  JobCardId: number;
  CustName: string;
  CustomerName: string;
  JobCardName: string;
  OilGradeName: string;
  CharacteristicName: string;
  SampleNo: string;
  SampleTakenBy: string;
  SamplingPoint: string;
  Component: string;
  SampledDate: string;
  DisplayDate: string;
  SpId: number;
  SpIdNo: string;
  OilGradeId: number;
  SampleDescription: string;
  Remarks: string;
  SampleStatusTypeId: number;
  CharacteristicId: number;
  LstSampleChars: CharacteristicModel[];
  LstAnalysis: AnalysisElementSectionTypeModel[];
  lstChars: CharacteristicsDDLModel[];
  SampleReceivedDate: string;
  FerroResults: FerroGraphyResult;
  FerroFileImages: FerroGraphyImages[];
  SampleTypeId: number;
  lstGroupSections: ResponseDto[];
  Result: string;

}

export class CharacteristicModel {
  SampleCharId: number;
  SampleId: number;
  CharacteristicId: number;
}
export class JobCardDDLModel {
  JobCardId: number;
  JobCardNumber: string;
}
export class OilGradeDDLModel {
  OilGradeId: number;
  Name: string;
}
export class CharacteristicsDDLModel {
  CharacteristicId: number;
  Name: string;
}
export class SampleStatusDDLModel {
  SampleStatusTypeId: number;
  Name: string;
}
export class GraphTempTypeDDLModel {
  GraphTemplateTypeId: number;
  Name: string;
}
export class SampleSearchFields {
  SampleNo: string;
  SpId: number;
  CustomerId: number;
  LabIds: any;
  JobCardId: number;
  JobCardName: string;
  JobCardNumber: string;
  ReceivedDateFrom: string;
  ReceivedDateTo: string;
  PublishedDateFrom: string;
  PublishedDateTo: string;
  SampleStatusTypeId: number;
  SampleTypeId: number;
  PageNo: number;
  PageSize: number;
}
export class FileDetailsModel {
  ImgBinary: string;
  FileName: string;
  FilePath: string;
  FileExtension: string;
  ImgData: string;
}

export class AnalysisElementSectionTypeModel {
  AnalysisElementSectionTypeId: number;
  Name: string;
  CustomerId: number;
  CharacteristicId: number;
  CharacteristicName: string;
  UnitId: number;
  TestMethodId: number;
  Result: string;
  TestRatingId: number;
  SampleResultId: number;
  NLimits: string;
  WLimits: string;
  CLimits: string;
  OrderId: number;
  LstAnalysisElements: AnalysisElementTypeModel[];
}

export class AnalysisElementTypeModel {
  AnalysisElementTypeId: number;
  CharacteristicId: number;
  CharName: string;
  OrderId: number;
  AnalysisElementSectionTypeId: number;
  TestMethodId: number;
  Result: string;
  TestRatingId: number;
  SampleRsltDetails: SampleResultsCharsModel
}

export class TestMethodModel {
  TestMethodId: number;
  Name: string;
  TestMethodCode: string;
  Description: string;
  UnitId: number;
}

export class TestRatingModel {
  TestRatingId;
  Name: string;
}

export class SampleResultsCharsModel {
  SampleResultId: number;
  SampleId: number;
  CharacteristicId: number;
  Result: string;
  TestRatingId: number;
  UnitId: number;
  TestMethodId: number;
}

export class JobCardModel {
  JobCardId: number;
  LabIds: any;
  CustomerId: number;
  JobCardNumber: string;
  ReceivedFrom: string;
  ReceivedTo: string;
  PageNo: number;
  PageSize: number;
  lstJobCardChars: CharacteristicModel[];
  lstCharIds: number[];
}

export class FerroGraphyImages {
  ImageId: number;
  SampleId: number;
  Path: string;
  FileName: string;
  Description: string;
}

export class FerroGraphyResult {
  SampleId: number;
  Recommendation: string;
  Recommendation2: string;
  WpConcentration: string;
  Dl: string;
  Ds: string;
  Plp: string;
  AllowableWpcLimit: string;
  Gw: string;
  GwSize: string;
  Bw: string;
  BwSize: string;
  Sw: string;
  SwSize: string;
  CuAlloy: string;
  CuAlloySize: string;
  BabbitBw: string;
  BabbitBwSize: string;
  CreatedBy: number;
  CreatedDate: any;
  UpdatedBy: number;
  UpdatedDate: any;
  SampledDate: any;
}
export class ResponseDto {
  Id: number;
  Name: string;
}

export class DeletedDataSearchModel {
  ScreenTypeId: number;
  JobCardNumber: string;
  LabIds: any;
  CustomerId: number;
  PageNo: number;
  PageSize: number;
}
export class EquipmentCategory{
  EquipmentCategoryId:number;
  EquipmentCategoryName : string;
}
export class OverAllTestRatingModel {
  TestRatingId:number;
  AnalysisSectionId :number;
}

export class JobCardsListModel {
  JobCardNumber: string;
  DisplayText: string;
}